          <ng-container *ngIf="categoryId === 2 || categoryId === 8">
              <div
                  style="width: 200px; position: relative; cursor: pointer; overflow: hidden;"
                  [style.height]="categoryId === 8 ? '110px' : '90px'"
                  (click)="openModal()">
                  <img
                      [src]="imageUrl"
                      style="width: 100%; height: 100%; object-fit: contain; object-position: center;"
                      alt="Imagen del producto">
              </div>
          </ng-container>

         <ng-container *ngIf="categoryId === 1 || categoryId === 6 || categoryId === 9">
          <img
            [src]="imageUrl"
            style="width: 100%; cursor: pointer; object-fit: cover; object-position: center;"
            [ngStyle]="{
              'height': categoryId !== 1 ? '342.5px' : '352.5px',
              'border-top-left-radius': '7px',
              'border-bottom-left-radius': '7px',
              'filter': 'brightness(0.85)'
            }"
            (click)="openModal()"
            alt="Imagen del producto">
        </ng-container>

          <ng-container *ngIf="categoryId === 1 || categoryId === 6 || categoryId === 9">

             <ng-container *ngIf="categoryId === 1">
              <div  *ngIf="mealsData !== ''"  class="d-flex" style="height: 35px;position: absolute; top: 26px;left:10px">
                <div class="d-flex align-items-center pl-1 pr-2" style="background-color: white; border-radius: 50rem;gap: .25em; border: 1px solid black">
                    <div class="d-flex align-items-center justify-content-center" style="width: 26px;height: 26px;border-radius: 50%;"
                      [ngStyle]="{'background-color': clientsSettingAppBooking?.clients_setting_global?.color_main_1}">
                    <img style="width: 24px; object-fit: contain;"
                      [src]="mealsData"
                      onerror="if (this.src != 'assets/img/app/rent-a-car-default.png') this.src = 'assets/img/app/rent-a-car-default.png';"
                      alt="Logo del proveedor">
                  </div>
                  <p class="mb-0" style="font-size: 11px;color: black">{{mealsNameRoom}}</p>
                </div>


              </div>
             </ng-container>

              <div *ngIf="logoUrl !== ''" class="d-flex" style="height: 35px;position: absolute; bottom: 15px;left:5px">
                <img style="max-width: 60px; width: 60px; height: 35px; object-fit: contain;"
                    [src]="logoUrl"
                    onerror="if (this.src != 'assets/img/app/rent-a-car-default.png') this.src = 'assets/img/app/rent-a-car-default.png';"
                    alt="Logo del proveedor">
              </div>

              <ng-container *ngIf="categoryId === 1 && exclusiveDeal !== null">
              <div  *ngIf="mealsData !== ''"  class="d-flex" style="height: 35px;position: absolute; bottom: 38px;right:20px">
                <div class="d-flex align-items-center justify-content-center" style="width: 60px;height: 60px;background-color: white; border-radius: 50% 10% 50% 50%; border: 1px solid black">
                    <div class="d-flex align-items-center justify-content-center" style="width: 50px;height: 50px;border-radius: 50%;"
                      [ngStyle]="{'background-color': clientsSettingAppBooking?.clients_setting_global?.color_main_1}">

                          <p *ngIf="exclusiveDeal === 'TOP_HOTEL'" class="mb-0" style="font-family: 'Poppins', sans-serif;font-weight:500;font-size: 9px;color: black; line-height: 1;width: min-content">Top Hotel</p>
                          <p *ngIf="exclusiveDeal === 'EXCLUSIVE_DEAL'" class="mb-0" style="font-family: 'Poppins', sans-serif;font-weight:500;font-size: 9px;color: black; line-height: 1;width: min-content">Oferta Exclusiva</p>

                  </div>

                </div>
              </div>
             </ng-container>

          </ng-container>

          <!-- Logos - Solo para categoryId === 2 (Rent-a-car) -->
          <div *ngIf="categoryId === 2 " class="d-flex flex-column align-items-center mb-4 ml-2">

            <div *ngIf="logoUrl !== ''" class="d-flex mt-3" style="height: 35px;">
              <!-- <img style="max-width: 120px; width: 120px; height: 55px; object-fit: contain;"
                  [src]="logoUrl"
                  onerror="if (this.src != 'assets/img/app/rent-a-car-default.png') this.src = 'assets/img/app/rent-a-car-default.png';"
                  alt="Logo del proveedor"> -->
            </div>

            <div class="d-flex"
                style="height: 35px; border-radius: 2px; border: 1px solid #cfcfcf; width: auto;margin-top:.70em">
              <img style="max-width: 95px; width: 95px; height: 35px; object-fit: contain; padding: 6px;"
                  [src]="supplierLogo"
                  onerror="if (this.src != 'assets/img/app/rent-a-car-default.png') this.src = 'assets/img/app/rent-a-car-default.png';"
                  alt="Logo del suplier">
              <div class="h-auto d-flex justify-content-center align-items-center"
                  style="border-radius: 0 2px 0 0; border-left: 1px solid #cfcfcf; background-color: #defced; width: 35px;">
                <p class="mt-3" style="font-weight: 500; font-family: 'Rubik'; font-size: 12px;">
                  {{ rentalCarData }}
                </p>
              </div>
            </div>

          </div>
